import { Component, OnInit } from '@angular/core';
import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { Fullscreenable, FullscreenBreadcrumb, FullscreenButton } from 'src/app/_interfaces/fullscreen';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { FullscreenService } from 'src/app/_provider/fullscreen.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { WawiConnectorService } from 'src/app/_provider/wawi-connector/wawi-connector.service';

@Component({
  selector: 'app-crm-detail-page',
  templateUrl: './crm-detail-page.page.html',
  styleUrls: ['./crm-detail-page.page.scss'],
})
export class CrmDetailPagePage implements OnInit, Fullscreenable<CrmDetailPagePage> {

  public isModal: boolean = false

  //Fullscreenable
  public isFullscreen: boolean;
  
  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private feedback: FeedbackService,
    private fullscreenSrv: FullscreenService,
    public resizeManager: ResizeManagerService,
    private appAvailability: AppAvailability,
    public platform: Platform,
    private generalSrv: GeneralService,
    private ticketSrv: TicketEmployee.TicketService,
    public wawiConnectorSrv: WawiConnectorService
  ) { }

  async ngOnInit() {
    await this.wawiConnectorSrv.initConnector()
    
  }

  public async closePage(){
    await this.feedback.hideKeyboardOnIOS()
    if(this.isModal) await this.modalCtrl.dismiss()
    else await this.navCtrl.pop()
  }

  public async toogleFullscreen(): Promise<void> {
    await this.fullscreenSrv.openModalInFullscreen(CrmDetailPagePage, this)
  }

  public async openExternal(){
    if(this.wawiConnectorSrv.connector.executable){
      const openResult: HttpFunctionResult = await this.wawiConnectorSrv.connector.openCustomer(this.generalSrv.activeCrmValue.managerId)
      if(openResult.success) this.feedback.showInformationToast(`Adresse wurde in ${this.wawiConnectorSrv.appName} geöffnet.`, "Information", 2000);
      else this.feedback.showError(openResult.message);
    }
  } 

}
 